import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { AiManagementColumn } from 'store/modules/ai_management_store/types';
import AiManagementModalHeader from 'components/molecules/ai_management_modal_header';
import { Container } from './styles';

export const COLUMN_COLORS = [
  '#006D91',
  '#3949AB',
  '#5B6EF5',
  '#7A4CC9',
  '#C23D8F',
  '#D9486E',
  '#D97706',
  '#9A5C2E',
  '#7C8C2F',
  '#3C8D5A',
  '#00897B',
  '#0097A7',
];

interface AiManagementColumnColorModalProps {
  column: AiManagementColumn | null;
  show: boolean;
  onClose: () => void;
  onSave: (id: number, color: string) => void;
}

const AiManagementColumnColorModal: React.FC<AiManagementColumnColorModalProps> = ({
  column,
  show,
  onClose,
  onSave,
}) => {
  const [selected, setSelected] = useState<string>(column?.color ?? '');

  useEffect(() => {
    if (show) setSelected(column?.color ?? '');
  }, [show, column]);

  const handleSave = () => {
    if (column && selected && selected !== column.color) onSave(column.id, selected);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered style={{ zIndex: 3000000005 }}>
      <Container>
        <AiManagementModalHeader title="Alterar cor da coluna" onClose={onClose} />

        <div className="color-body p-4">
          <div className="mb-3">Selecione a cor:</div>
          <div className="row no-gutters">
            {COLUMN_COLORS.map((color) => (
              <div key={color} className="col-3 p-1">
                <button
                  type="button"
                  className="color-swatch w-100 d-flex align-items-center justify-content-center"
                  style={{ background: color }}
                  aria-label={`Cor ${color}`}
                  aria-pressed={selected === color}
                  onClick={() => setSelected(color)}
                >
                  {selected === color && <i className="material-icons text-white">check</i>}
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="color-footer d-flex justify-content-center px-4 py-3">
          <button type="button" className="btn btn-primary px-4" onClick={handleSave}>
            Salvar
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default AiManagementColumnColorModal;
